import React from 'react';

const CamionPage = () => {
  return (
    <div className="container mx-auto px-4 py-12 min-h-screen">
      <h1 className="text-4xl font-black uppercase text-center mb-10 text-[var(--belgo-text, #000)] tracking-tight">
        Camion Belgo
      </h1>
      <div className="w-full max-w-5xl mx-auto" style={{ height: '80vh' }}>
        <iframe 
          src="https://www.restobelgo.com/assets/files/pdf/22z8rqf9_Belgo_menu-foodtruck_2026-80234699.pdf" 
          title="Camion Belgo"
          width="100%" 
          height="100%" 
          className="border-0 shadow-xl rounded-lg"
        />
      </div>
    </div>
  );
};

export default CamionPage;
